// src/pages/ContraRecord/components/exportContraRecordCsv.js
import _ from "lodash";
import dayjs from "dayjs";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const formatDate = (date) =>
  date ? dayjs(date).format("DD MMM YYYY") : "-";

const triggerDownload = (rows, filename) => {
  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

/**
 * @param {object} params
 * @param {Array}   params.list            - state.contraRecord.list
 * @param {Array}   params.listWithDetails - state.contraRecord.listWithDetails
 * @param {object}  params.filters         - state.contraRecord.filters
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportContraRecordCsv = ({
  list,
  listWithDetails,
  filters,
  title    = "Contra Record Report",
  filename = "contra_record",
}) => {

  // ── With Details ───────────────────────────────────────────────────────────
  if (filters.recordType === "with details") {
    const headers = [
      "No.", "VCH", "Date", "Customer", "Receipt By",
      "Detail Account", "Amount",
    ].map(escape);

    const dataRows = [];

    listWithDetails.forEach((row, i) => {
      const details = row.details || [];

      details.forEach((d, di) => {
        dataRows.push([
          di === 0 ? i + 1 : "",
          di === 0 ? (row.con_code  || "") : "",
          di === 0 ? formatDate(row.created_date) : "",
          di === 0 ? (row.acc_name  || "") : "",
          di === 0 ? (row.full_name || "") : "",
          d.into_acc_name || "",
          fmt(d.con_total),
        ].map(escape));
      });

      // row sub-total
      const rowTotal = _.sumBy(details, "con_total");
      dataRows.push(["", "", "", "", "", "Total:", fmt(rowTotal)].map(escape));
      dataRows.push([]); // blank separator
    });

    const grandTotal = _.sumBy(listWithDetails, (r) =>
      _.sumBy(r.details, "con_total")
    );

    const totalRow = [
      "Grand Total:", "", "", "", "", "", fmt(grandTotal),
    ].map(escape);

    return triggerDownload([[title], [], headers, ...dataRows, totalRow], filename);
  }

  // ── Without Details (default) ──────────────────────────────────────────────
  const headers = [
    "No.", "VCH No", "Date", "From Account", "To Account",
    "Receipt By", "Amount",
  ].map(escape);

  const dataRows = list.map((row, i) => [
    i + 1,
    row.contra_code    || "",
    formatDate(row.created_date),
    row.from_acc_name  || "",
    row.to_acc_name    || "",
    row.full_name      || "",
    fmt(row.tran_amount),
  ].map(escape));

  const grandTotal = _.sumBy(list, (r) => Number(r.tran_amount) || 0);

  const totalRow = [
    "Grand Total:", "", "", "", "", "", fmt(grandTotal),
  ].map(escape);

  triggerDownload([[title], [], headers, ...dataRows, [], totalRow], filename);
};